import { Command } from 'commander'
import { InitCommand } from './init'
import { CheckConfigCommand } from './check-config'
import { PublishCommand } from './publish'
import { CreateCommand } from './create'
import { PreviewCommand } from '@/domains/project/preview'

const projectCommands = [
  InitCommand,
  CheckConfigCommand,
  CreateCommand,
  PreviewCommand,
  PublishCommand,
]

const projectDomain = new Command('project')
projectDomain.description('Manage scalar project')
projectCommands.forEach((command) => projectDomain.addCommand(command()))
export default projectDomain
